import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import OfferFinancialServicesItemSummary from './OfferFinancialServicesItemSummary';
import { Grid } from '@mui/material';
import { RightsContext } from 'providers/RightsContext';

export const OfferFinancialServicesSummary = ({ t, items, allServices, currencyCode }) => {
  const { financialServicesWrite } = useContext(RightsContext);

  return (
    <>
      {items.length > 0 ? (
        <div>
          <Grid container spacing={1}>
            {items.map((item, idx) => (
              <OfferFinancialServicesItemSummary key={item.id} item={item} idx={idx} currencyCode={currencyCode} />
            ))}
          </Grid>
        </div>
      ) : (
        allServices.length === 0 && <div>{financialServicesWrite ? t('ResultsNotFound') : t('NotApply')}</div>
      )}
    </>
  );
};

OfferFinancialServicesSummary.displayName = 'OfferFinancialServicesSummary';

OfferFinancialServicesSummary.propTypes = {
  t: PropTypes.func.isRequired,
  items: PropTypes.array.isRequired,
  allServices: PropTypes.array.isRequired,
  currencyCode: PropTypes.string
};

export default withTranslation()(OfferFinancialServicesSummary);
